exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ext-dropdown .el-dropdown{height:24px;padding:2px 6px}.ext-dropdown .el-dropdown-link{cursor:pointer;color:#0c64eb;position:relative;top:2px}.ext-dropdown .el-icon-arrow-down{font-size:12px}.el-dropdown-menu .iconed .no-icon{padding-left:17px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-25cb863a","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/compo/ctrl/ExtDropdown.vue
// module id = 2148
// module chunks = 0